import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer-part" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-12\"><div class=\"footer-bottom\"><p class=\"footer-copytext\">© All Copyrights Reserved by <a target=\"_blank\" href=\"https://www.sisflexsa.com/\">Sisflexsa SRL</a></p></div></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}